<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>经络报告列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.id" auto-complete="off" placeholder="输入报告id"></el-input>
      </el-form-item>
      <el-form-item prop="search" v-if="isSuper">
        <el-input size="small" v-model="formInline.appId" auto-complete="off" placeholder="输入appId"></el-input>
      </el-form-item>
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.extId" auto-complete="off" placeholder="输入extId"></el-input>
      </el-form-item>
      <el-form-item prop="search">
        <el-date-picker
          size="small"
          v-model="formInline.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          placeholder="开始日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="search">
        <el-date-picker
          size="small"
          v-model="formInline.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch()">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-collection" @click="handleExport()">导出</el-button>
      </el-form-item>
      <el-form-item>
        自动更新
        <el-switch
          v-model="autoUpdate"
          :active-value="true"
          :inactive-value="false"
          @change="autoUpdateList()">
        </el-switch>
      </el-form-item>

    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="id" label="ID" width="150">
      </el-table-column>
      <el-table-column prop="reportTime" label="报告时间" width="140">
      </el-table-column>
      <el-table-column prop="user.name" label="姓名" width="140">
      </el-table-column>
      <el-table-column prop="appId" label="应用ID">
      </el-table-column>
      <el-table-column prop="extId" label="用户ID">
      </el-table-column>
      <el-table-column prop="code" label="经络结果代号"></el-table-column>
      <el-table-column prop="pushResponse" label="推送结果" width="100">
      </el-table-column>
      <el-table-column prop="feedbackFlag" label="认可反馈" width="80">
        <template slot-scope="scope">{{scope.row.feedbackFlag?(scope.row.feedbackFlag===1?'认可':'不认可'):'未反馈'}}</template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="440">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-search" @click="editBusiness(scope.$index, scope.row)">查看</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">报告</el-button>
          <el-button size="mini" @click="handlePush(scope.$index, scope.row)">推送</el-button>
          <el-button size="mini" @click="handleCompare(scope.$index, scope.row)">对比</el-button>
          <el-button size="mini" @click="recalculate(scope.$index, scope.row)">重新计算</el-button>
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog title="报告明细" :visible.sync="bfVisible" width="50%" @click="closeBfDialog">
      <div>
        <div style="margin-bottom:20px;margin-top:20px;">
          <p><strong>报告ID：</strong>{{result.id}}</p>
          <p><strong>经络结果代号：</strong>{{result.code}}</p>
          <p><strong>用户：</strong>{{result.user.name}}</p>
          <p><strong>体能状态：</strong>{{result.energy}}</p>
          <p><strong>H2：</strong>{{result.diagnose.H2}}</p>
          <p><strong>L2：</strong>{{result.diagnose.L2}}</p>
          <p><strong>H4：</strong>{{result.diagnose.H4}}</p>
          <p><strong>L4：</strong>{{result.diagnose.L4}}</p>
          <p><strong>问题经络：</strong>{{result.diagnose.meridianStr}}</p>
          <p><strong>主要症状：</strong>
            <br/>
            <span v-for="zz in result.diagnose.detail">【{{zz.meridian}}】{{zz.symptom}} <br/></span>
          </p>
          <p><strong>调理方案：</strong>{{result.diagnose.advice}}</p>
          <p><strong>对比上次报告ID：</strong>{{result.compareId}} <a href="javascript:void(0)" @click="viewLink(result)" v-if="result.compareId>0">查看报告</a></p>
          <p><strong>对比上次改善：</strong>{{result.compareDesc}}</p>
          <hr/>
          <h3 style="text-align: center">AI总结</h3>
          <div><vue-markdown :source="result.aiSummary"></vue-markdown></div>
          <hr/>
          <h3 style="text-align: center">AI调理建议</h3>
          <vue-markdown :source="result.aiAdvice"></vue-markdown>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBfDialog">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="指定要对比的经络报告" :visible.sync="bf2Visible" width="30%" @click="closeBf2Dialog">
      <el-form label-width="120px" :model="editForm2" ref="editForm" :inline-message="true">
        <input type="hidden" v-model="editForm2.id"/>
        <el-form-item label="上次经络报告ID" prop="appId">
          <el-input size="small" v-model="editForm2.compareId" auto-complete="off" style="width: 280px;" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="bf2Submit" type="primary">确定</el-button>
        <el-button size="small" @click="closeBf2Dialog">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  loadMeridianList, rePushMeridian, compareMeridian, recalculate, physiqueAiAnalyze, meridianAiAnalyze
} from '../../api/userMG'
  import {
    joinArgs
  } from '../../utils/util'
  import Pagination from '../../components/Pagination'
  import {getStore} from "../../utils/util";
import VueMarkdown from 'vue-markdown';

  export default {
    data() {
      return {
        listData:[],
        autoUpdate:false,
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        bfVisible: false,
        bf2Visible: false,
        title: '添加',
        isSuper: parseInt(getStore('isSuper')),
        editForm: {
          deptId: '',
          deptName: '',
          deptNo: '',
          token: localStorage.getItem('logintoken')
        },
        editForm2:{
          id:0,
          compareId:0
        },
        businessForm: {},
        formInline: {
          pageNum: 1,
          pageSize: 10,
          startTime:'',
          endTime:''
        },
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        list: [],
        result:{
          user:{},
          diagnose:{},
          energy:0
        }

      }
    },
    // 注册组件
    components: {
      Pagination,VueMarkdown
    },

    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      viewLink(res){
        window.open('/aimed-api/meridian-report/'+res.compareId+'.html')
      },
      autoUpdateList(){
        console.log(this.autoUpdate);
        if (this.autoUpdate){
          this.getdata()
          setTimeout(this.autoUpdateList, 10000)
        }
      },
      getdata(parameter) {
        this.loading = true
        loadMeridianList(parameter)
          .then(res => {
            this.loading = false
            if (res.code !== '0000') {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.listData = res.data.list
              for (let i=0;i<this.listData.length;i++){
                let row = this.listData[i]
                row.diagnose.meridianStr = row.diagnose.meridians.join('，')
                if (!row.aiSummary){
                  row.aiSummary = "暂未生成";
                }
                if (!row.aiAdvice){
                  row.aiAdvice = "暂未生成";
                }
              }
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },

      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },

      handleSearch: function(index, row){
        this.formInline.pageNum = 1
        this.getdata(this.formInline)
      },
      handleExport: function(index, row){
        let url = '/aimed-api/admin/meridian/export';
        let args = joinArgs(this.formInline)
        window.open(url+'?'+args)
      },
      handleEdit: function (index, row) {
        window.open(row.reportUrl)
      },
      handlePush: function (index, row) {
        rePushMeridian({
          id:row.id
        })
          .then(res => {
            this.loading = false
            if (res.code !== '0000') {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },
      recalculate: function (index, row) {
        this.$confirm('此操作将删除旧的对比结果（不可恢复）再重新计算, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          recalculate({
            id:row.id
          })
            .then(res => {
              this.loading = false
              if (res.code !== '0000') {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('列表加载失败，请稍后再试！')
            })
        })

      },

      bf2Submit(){
        compareMeridian(this.editForm2)
          .then(res => {
            this.loading = false
            if (res.code !== '0000') {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.bf2Visible = false
              this.editForm2.compareId = 0
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      },
      closeBfDialog() {
        this.bfVisible = false;
      },
      closeBf2Dialog() {
        this.bf2Visible = false;
      },
      handleAvatarSuccess(res, file) {
        if (res.code == 0) {
          this.editForm.avatarUrl = res.data.url;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      },
      beforeAvatarUpload(file) {
        const formatOk = (file.type === 'image/jpeg' || file.type === 'image/png');
        const sizeLt1M = file.size / 1024 / 1024 < 1;

        if (!formatOk) {
          this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        }
        if (!sizeLt1M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return formatOk && sizeLt1M;
      },
      editBusiness(index, row) {
        this.bfVisible = true;
        this.result = row
      },
      handleCompare(index, row) {
        this.bf2Visible = true;
        this.editForm2.id = row.id
      },
      aiAnalyze: function (row) {
        meridianAiAnalyze({id:row.id})
          .then(res => {
            if (res.code === '0000') {
              this.$message({
                type: 'success',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('可能网络故障，请稍后再试！')
          })
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .el-form-item {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/meridian/list.vue